export default __webpack_public_path__ + "static/media/embassy.5b7f1ecc.jpg";